import { Button, Col, Form, Input, Row, Typography } from 'antd';
import Title from 'antd/lib/typography/Title';
interface ForgotPasswordComponentProps {
  onFinish: (email: string) => void;
  onCancel: () => void;
}
const { Text } = Typography;

function ForgotPasswordComponent({
  onFinish,
  onCancel,
}: ForgotPasswordComponentProps) {
  const [form] = Form.useForm();

  return (
    <>
      <Row justify="center" style={{ marginTop: '50px' }}>
        <Col span={8}>
          <Title level={2}>비밀번호 재설정</Title>
        </Col>
      </Row>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row justify="center">
          <Col span={8}>
            <Form.Item
              name="email"
              rules={[
                {
                  type: 'email',
                  message: '이메일 입력이 잘못 되었습니다.',
                },
                {
                  required: true,
                  message: '이메일 입력을 입력 하세요.',
                },
              ]}
            >
              <Input placeholder="이메일을 입력해 주세요." />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={8}>
            <Text>
              가입하신 이메일로 새 비밀번호를 설정할 수 있는 링크가 전송됩니다.
            </Text>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '30px' }}>
          <Col span={8}>
            <Form.Item>
              <Button
                type="primary"
                style={{ width: '100%' }}
                htmlType="submit"
              >
                전송
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={8}>
            <Button
              htmlType="button"
              style={{ width: '100%' }}
              onClick={onCancel}
            >
              로그인 페이지로 가기
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}
export default ForgotPasswordComponent;
